export const PAGE_SIZE = 20;
export const DATE_FORMAT = "yyyy-MM-dd";
